import { Component, OnInit } from '@angular/core';
import { UtilityService } from './services/utility/utility.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    public readonly utility: UtilityService
  ) { }

  ngOnInit() { }

  redirectToCompanyWebiste(): void {
    window.open('https://rialpayment.ir', 'blank');
  }

}
